import { render, staticRenderFns } from "./MTourFrame.vue?vue&type=template&id=2c004cab&"
import script from "./MTourFrame.vue?vue&type=script&lang=ts&"
export * from "./MTourFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports